/**
 * Service with translation utilities.
 *
 * @type {ngService}
 */
export class TmrTranslate {
  static ngType = 'service'

  constructor($translate, TmrLanguage) {
    'ngInject'
    Object.assign(this, { $translate, TmrLanguage })
  }

  /**
   * Translates all the properties of an object.
   *
   * @param {object} obj An object where every properties value is a translation key.
   */
  object(obj) {
    return this.TmrLanguage.init()
      .then(() => this.$translate(Object.values(obj)))
      .then(translated => {
        for (const key in obj) obj[key] = translated[obj[key]]
        return obj
      })
  }
}
